import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import AnalyseIcon from './icons/AnalyseIcon'
import MatchIcon from './icons/MatchIcon'
import StrengthIcon from './icons/StrengthIcon'

export default function EvaluationEmpty({
  className,
  career,
  onPressCreateCareer,
  onPressCreateTalent
}) {
  const { t } = useTranslation()

  const features = useMemo(
    () => [
      {
        icon: <StrengthIcon />,
        title: t('discover.evaluation_section.empty.features.1.title'),
        description: t(
          'discover.evaluation_section.empty.features.1.description'
        )
      },
      {
        icon: <MatchIcon />,
        title: t('discover.evaluation_section.empty.features.2.title'),
        description: t(
          'discover.evaluation_section.empty.features.2.description'
        )
      },
      {
        icon: <AnalyseIcon />,
        title: t('discover.evaluation_section.empty.features.3.title'),
        description: t(
          'discover.evaluation_section.empty.features.3.description'
        )
      }
    ],
    [t]
  )

  return (
    <div className={clsx('w-full rounded-lg bg-white p-6', className)}>
      {/* <div className='flex flex-col items-center justify-center gap-y-2 py-4'>
        <p className='text-sm font-normal text-rockGrey'>
          {career
            ? t('discover.evaluation_section.empty.talent.title')
            : t('discover.evaluation_section.empty.title')}
        </p>
        <button
          onClick={career ? onPressCreateTalent : onPressCreateCareer}
          className='text-sm font-medium text-buttonSecondaryBlue'
        >
          {career
            ? t('discover.evaluation_section.empty.talent.button')
            : t('discover.evaluation_section.empty.button')}
          <svg
            width='12px'
            height='11px'
            viewBox='0 0 12 11'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            className='ml-1 inline-block'
          >
            <g
              id='Page-1'
              stroke='none'
              strokeWidth='1'
              fill='none'
              fillRule='evenodd'
            >
              <g id='Icons' fill='#1660F3'>
                <path
                  d='M0,5.2499975 C0,4.8357875 0.33579,4.5 0.75,4.5 L9.4393,4.5 L6.21967,1.2803275 C5.92678,0.9874375 5.92678,0.5125575 6.21967,0.2196675 C6.51256,-0.0732225 6.98744,-0.0732225 7.28033,0.2196675 L11.7803,4.7196675 C12.0732,5.0125575 12.0732,5.4874375 11.7803,5.7803275 L7.28033,10.2802975 C6.98744,10.5731975 6.51256,10.5731975 6.21967,10.2802975 C5.92678,9.9873975 5.92678,9.5125975 6.21967,9.2196975 L9.4393,6 L0.75,6 C0.33579,6 0,5.6642075 0,5.2499975 Z'
                  id='Path'
                ></path>
              </g>
            </g>
          </svg>
        </button>
      </div> */}
      <div className='mt-4 grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3'>
        {features.map((feature, index) => (
          <div key={index} className='flex flex-col items-center text-center'>
            <div className='mb-5'>{feature.icon}</div>
            <h4 className='text-base font-semibold text-darkGrey'>
              {feature.title}
            </h4>
            <p className='mt-2 text-sm/snug text-rockGrey'>
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}

EvaluationEmpty.propTypes = {
  className: PropTypes.string
}
